export const comments_5150484 = {"data":{"data":[],"links":{}}}